// import React from 'react';
// import SecondNav from "../Navbar/SecondNav";
// import TopNavbar from "../Navbar/TopNavbar";
// import ChatPopup from "./ChatPopup";
// import { Box, Typography, Container, Accordion, AccordionSummary, AccordionDetails, useTheme, useMediaQuery } from '@mui/material';
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
// import Footer from './Footer';
// import { motion } from 'framer-motion';

// function FAQ() {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

//   // FAQ data
//   const faqs = [
//     {
//       question: "What is Armour Coating, and how does it benefit my vehicle?",
//       answer: "Armour Coating is a premium protective layer applied to your vehicle's exterior to shield it from scratches, UV rays, and environmental damage. It enhances the gloss of your car while providing long-lasting protection, typically for up to 5 years with proper maintenance.",
//     },
//     {
//       question: "How does Nano Armor Protection differ from Armour Coating?",
//       answer: "Nano Armor Protection uses advanced nanotechnology to create an even thinner, yet highly durable protective film. It offers superior resistance to water, dirt, and chemicals compared to traditional Armour Coating, making it ideal for harsh weather conditions.",
//     },
//     {
//       question: "What does the Detailing service include?",
//       answer: "Our Detailing service includes a thorough cleaning of both the interior and exterior of your vehicle. This involves washing, waxing, polishing, vacuuming, and cleaning of upholstery, dashboard, and windows to restore your car to a showroom-like condition.",
//     },
//     {
//       question: "Is Window Tinting safe for my car windows?",
//       answer: "Yes, our Window Tinting service uses high-quality films that are safe for your car windows. They reduce glare, block harmful UV rays, and provide privacy without compromising visibility. We ensure proper installation to prevent bubbling or peeling.",
//     },
//     {
//       question: "How long does each service take?",
//       answer: "The duration varies by service: Armour Coating and Nano Armor Protection typically take 4-6 hours, Detailing takes 2-4 hours, and Window Tinting takes 1-2 hours. Times may vary based on the condition and size of your vehicle.",
//     },
//     {
//       question: "Can I book multiple services at once?",
//       answer: "Absolutely! You can select multiple services when booking through our website. We'll schedule them efficiently to minimize your wait time. Feel free to add any special requests in the 'Additional Notes' section during booking.",
//     },
//   ];

//   // Animation variants for the FAQ items
//   const faqVariants = {
//     hidden: { opacity: 0, y: 20 },
//     visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: 'easeOut' } },
//   };

//   return (
//     <div
//       className="home-page"
//       style={{
//         width: "100%",
//         minHeight: "100vh",
//         background: "linear-gradient(to bottom, #0D47A1, #42A5F5)", // New blue gradient background
//         position: "relative",
//       }}
//     >
//       <TopNavbar />
//       <SecondNav />

//       {/* FAQ Section */}
//       <Box
//         sx={{
//           minHeight: '100vh',
//           background: "linear-gradient(to bottom, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.05))", // Subtle white overlay
//           position: 'relative',
//           zIndex: 1,
//           display: 'flex',
//           flexDirection: 'column',
//           alignItems: 'center',
//           justifyContent: 'center',
//           py: 6,
//           mt: 4,
//         }}
//       >
//         {/* Hero Section */}
//         <Box sx={{ textAlign: 'center', mb: 6 }}>
//           <motion.div
//             initial={{ opacity: 0, scale: 0.9 }}
//             animate={{ opacity: 1, scale: 1 }}
//             transition={{ duration: 1, ease: 'easeOut' }}
//           >
//             <Typography
//               variant="h2"
//               sx={{
//                 fontWeight: 'bold',
//                 color: '#fff',
//                 textShadow: '0 4px 8px rgba(0,0,0,0.5)',
//                 fontSize: { xs: '2.5rem', md: '4rem' },
//                 background: 'linear-gradient(45deg, #BBDEFB, #FFFFFF)',
//                 WebkitBackgroundClip: 'text',
//                 WebkitTextFillColor: 'transparent',
//               }}
//             >
//               Frequently Asked Questions
//             </Typography>
//           </motion.div>
//           <motion.div
//             initial={{ opacity: 0, y: 20 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.8, delay: 0.3, ease: 'easeOut' }}
//           >
//             <Typography
//               variant="h6"
//               sx={{
//                 color: '#fff',
//                 fontSize: { xs: '1.2rem', md: '1.5rem' },
//                 fontWeight: 300,
//                 mt: 2,
//                 letterSpacing: '0.5px',
//               }}
//             >
//               Find Answers to Your Questions About Our Services
//             </Typography>
//           </motion.div>
//         </Box>

//         {/* FAQ Accordion */}
//         <Container maxWidth="md">
//           <motion.div
//             initial="hidden"
//             animate="visible"
//             variants={{
//               hidden: { opacity: 0 },
//               visible: { opacity: 1, transition: { staggerChildren: 0.2 } },
//             }}
//           >
//             <Box
//               sx={{
//                 backgroundColor: 'rgb(7, 0, 0)', // Glassmorphism effect
//                 backdropFilter: 'blur(10px)',
//                 borderRadius: 8,
//                 boxShadow: '0 8px 30px rgba(0,0,0,0.3)',
//                 p: { xs: 3, sm: 4 },
//                 border: '1px solid rgba(255, 255, 255, 0.2)',
//               }}
//             >
//               {faqs.map((faq, index) => (
//                 <motion.div key={index} variants={faqVariants}>
//                   <Accordion
//                     sx={{
//                       backgroundColor: 'transparent',
//                       color: '#fff',
//                       borderBottom: index !== faqs.length - 1 ? '1px solid rgba(255, 255, 255, 0.2)' : 'none',
//                       '&:before': { display: 'none' },
//                     }}
//                   >
//                     <AccordionSummary
//                       expandIcon={<ExpandMoreIcon sx={{ color: '#fff' }} />}
//                       sx={{
//                         '& .MuiAccordionSummary-content': {
//                           fontWeight: '500',
//                           color: '#fff',
//                         },
//                         '&:hover': {
//                           backgroundColor: 'rgba(255, 255, 255, 0.05)',
//                         },
//                       }}
//                     >
//                       <Typography variant="h6" sx={{ fontSize: { xs: '1rem', md: '1.2rem' } }}>
//                         {faq.question}
//                       </Typography>
//                     </AccordionSummary>
//                     <AccordionDetails>
//                       <Typography sx={{ color: '#ddd', fontSize: { xs: '0.9rem', md: '1rem' } }}>
//                         {faq.answer}
//                       </Typography>
//                     </AccordionDetails>
//                   </Accordion>
//                 </motion.div>
//               ))}
//             </Box>
//           </motion.div>
//         </Container>
//       </Box>

//       <ChatPopup />
//       <Footer />
//     </div>
//   );
// }

// export default FAQ;


import React from 'react';
import SecondNav from "../Navbar/SecondNav";
import TopNavbar from "../Navbar/TopNavbar";
import ChatPopup from "./ChatPopup";
import {
  Box,
  Typography,
  Container,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  useTheme,
  useMediaQuery
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Footer from './Footer';
import { motion } from 'framer-motion';

function FAQ() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const faqs = [
    {
      question: "What is Armour Coating, and how does it benefit my vehicle?",
      answer: "Armour Coating is a premium protective layer applied to your vehicle's exterior to shield it from scratches, UV rays, and environmental damage. It enhances the gloss of your car while providing long-lasting protection, typically for up to 5 years with proper maintenance.",
    },
    {
      question: "How does Nano Armor Protection differ from Armour Coating?",
      answer: "Nano Armor Protection uses advanced nanotechnology to create an even thinner, yet highly durable protective film. It offers superior resistance to water, dirt, and chemicals compared to traditional Armour Coating, making it ideal for harsh weather conditions.",
    },
    {
      question: "What does the Detailing service include?",
      answer: "Our Detailing service includes a thorough cleaning of both the interior and exterior of your vehicle. This involves washing, waxing, polishing, vacuuming, and cleaning of upholstery, dashboard, and windows to restore your car to a showroom-like condition.",
    },
    {
      question: "Is Window Tinting safe for my car windows?",
      answer: "Yes, our Window Tinting service uses high-quality films that are safe for your car windows. They reduce glare, block harmful UV rays, and provide privacy without compromising visibility. We ensure proper installation to prevent bubbling or peeling.",
    },
    {
      question: "How long does each service take?",
      answer: "The duration varies by service: Armour Coating and Nano Armor Protection typically take 4-6 hours, Detailing takes 2-4 hours, and Window Tinting takes 1-2 hours. Times may vary based on the condition and size of your vehicle.",
    },
    {
      question: "Can I book multiple services at once?",
      answer: "Absolutely! You can select multiple services when booking through our website. We'll schedule them efficiently to minimize your wait time. Feel free to add any special requests in the 'Additional Notes' section during booking.",
    },
  ];

  const faqVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: 'easeOut' } },
  };

  return (
    <div
      className="home-page"
      style={{
        width: "100%",
        minHeight: "100vh",
        background: "linear-gradient(to bottom, #0D47A1, #42A5F5)",
        position: "relative",
      }}
    >
      <TopNavbar />
      <SecondNav />

      {/* FAQ Section */}
      <Box
        sx={{
          minHeight: '100vh',
          // backgroundImage: 'url("https://media.istockphoto.com/id/953587268/photo/man-sitting-in-car-and-texting-on-the-phone-stock-image.jpg?s=612x612&w=0&k=20&c=uW7ZNjg1uOeyqN9MlJMUnfziNLMk9HkLNp9G40wdW4s=")',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          position: 'relative',
          zIndex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          py: 6,
          mt: 4,
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: 'linear-gradient(to bottom, rgba(13,71,161,0.8), rgba(66,165,245,0.7))',
            //  background: "linear-gradient(to bottom, rgba(0, 0, 0, 0.85), rgba(0, 0, 0, 0.65))",
            zIndex: -1,
          }
        }}
      >
        {/* Hero Section */}
        <Box sx={{ textAlign: 'center', mb: 6 }}>
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1, ease: 'easeOut' }}
          >
            <Typography
              variant="h2"
              sx={{
                fontWeight: 'bold',
                color: '#fff',
                textShadow: '0 4px 8px rgba(0,0,0,0.5)',
                fontSize: { xs: '2.5rem', md: '4rem' },
                background: 'linear-gradient(45deg, #BBDEFB, #FFFFFF)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}
            >
              Frequently Asked Questions
            </Typography>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.3, ease: 'easeOut' }}
          >
            <Typography
              variant="h6"
              sx={{
                color: '#fff',
                fontSize: { xs: '1.2rem', md: '1.5rem' },
                fontWeight: 300,
                mt: 2,
                letterSpacing: '0.5px',
              }}
            >
              Find Answers to Your Questions About Our Services
            </Typography>
          </motion.div>
        </Box>

        {/* FAQ Accordion */}
        <Container maxWidth="md">
          <motion.div
            initial="hidden"
            animate="visible"
            variants={{
              hidden: { opacity: 0 },
              visible: { opacity: 1, transition: { staggerChildren: 0.2 } },
            }}
          >
            <Box
              sx={{
                backgroundColor: 'rgba(0, 0, 0, 0.75)',
                backdropFilter: 'blur(10px)',
                borderRadius: 8,
                boxShadow: '0 8px 30px rgba(0,0,0,0.3)',
                p: { xs: 3, sm: 4 },
                border: '1px solid rgba(255, 255, 255, 0.2)',
              }}
            >
              {faqs.map((faq, index) => (
                <motion.div key={index} variants={faqVariants}>
                  <Accordion
                    sx={{
                      backgroundColor: 'transparent',
                      color: '#fff',
                      borderBottom: index !== faqs.length - 1 ? '1px solid rgba(255, 255, 255, 0.2)' : 'none',
                      '&:before': { display: 'none' },
                    }}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon sx={{ color: '#fff' }} />}
                      sx={{
                        '& .MuiAccordionSummary-content': {
                          fontWeight: '500',
                          color: '#fff',
                        },
                        '&:hover': {
                          backgroundColor: 'rgba(255, 255, 255, 0.05)',
                        },
                      }}
                    >
                      <Typography variant="h6" sx={{ fontSize: { xs: '1rem', md: '1.2rem' } }}>
                        {faq.question}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography sx={{ color: '#ddd', fontSize: { xs: '0.9rem', md: '1rem' } }}>
                        {faq.answer}
                      </Typography>
                    </AccordionDetails>
                  </Accordion>
                </motion.div>
              ))}
            </Box>
          </motion.div>
        </Container>
      </Box>

      <ChatPopup />
      <Footer />
    </div>
  );
}

export default FAQ;
